/**
 * 保险相关的固定数据
 */

// 保险商品详情下方流程数据
export const insuranceDetailProcess = [{
  index: '01',
  title: '报案',
  content: '可通过如下方式报案：\n① 微信搜索“保单微服务”，关注服务公众号，通过【小马理赔】报案\n② 电话报案：致电400-678-8169 进行报案',
  icon: 'insurance-new/process-1.png',
  backgourndUrl: 'insurance/process-1.png',
},
{
  index: '02',
  title: '提交理赔资料',
  content: '报案后收到索赔指引邮件，了解资料要求、理赔流程及材料寄送地址。\n如不确定材料是否符合理赔要求，可将所有材料拍照发送至claim@huize.com进行预审核。',
  icon: 'insurance-new/process-2.png',
  backgourndUrl: 'insurance/process-2.png',
},
{
  index: '03',
  title: '理赔资料审核',
  content: '事故责任明确、理赔资料齐全的案件，审核周期：叮咚闪赔一般为3个工作日，普通类一般为5-7个工作日，重大类一般为20-22个工作日。',
  icon: 'insurance-new/process-3.png',
  backgourndUrl: 'insurance/process-3.png',
},
{
  index: '04',
  title: '领取赔款',
  content: '理赔款一般在结案后的1-2个工作日可以到账。\n为保障到账时效，建议在提交理赔资料时以工、农、中、建、交或邮储等银行卡作为收款账户。',
  icon: 'insurance-new/process-4.png',
  backgourndUrl: 'insurance/process-4.png',
}];

// 投保须知
export const insuranceDetailTips = ['如需报案或理赔协助服务，请拨打全国服务电话：400-678-8169。',
  '报案时，请您提供保单号(或有效证件号码)、出险人姓名、出险时间、出险地点、出险原因、治疗就医情况等基本信息。',
  '您报案后，我们将会给您发送索赔指引邮件，告知您资料要求和理赔流程。',
  '发生合同约定保险事故需要到医院接受治疗，请到合同约定的医院（一般是二级或二级以上公立医院）进行就诊治疗。并请提醒主治医生使用医保范围内用药、诊疗项目及服务设施。就诊的同时请妥善保存病历（包含首诊病历）、原始收费凭证、处方、诊断证明、检查化验报告、住院证明等就医相关材料，以便向保险公司办理索赔申请。',
  '一对一理赔协助：我们将全程协助您报案、告知您在当地如何处理、告知索赔所需相关证明资料、并监督保险公司理赔结案和协助催付赔款等。',
  '领款方式：通过银行转账的方式，保险公司将通过财务系统直接向您所指定的银行账户进行转账支付。需要您提供开户银行、户名、账号等信息，建议您选择工农中建交或邮储，以便保险公司快速处理。',
];

// 平台提供保险、用户自选的投保人申明
export const insuranceProtocol = [
  '投保时，本投保人已就该产品的保障内容以及保险金额向被保险人进行了明确说明，并征得其同意。',
  '本投保人授权慧择保险经纪有限公司作为本人的保险经纪人，并委托慧择保险经纪全权代为办理保险相关事宜。',
  '本投保人兹声明上述各项内容填写属实，并知道如果投保信息不真实，保险公司将有权拒赔，一切后果由本人承担。',
  '本投保人已完整阅读本产品投保须知、详细条款，尤其是保障责任、免除责任、犹豫期、费用扣除、退保、保险单现金价值、投保人、被保险人义务的内容等各重要事项。本投保人特此同意接受该条款及投保须知之全部内容。',
  '本投保人已明确了解该保险合同的成立、生效是以保险公司出具保单为准，确认非以支付保费为保险合同的成立要件。',
  '本投保人已明确并接受本计划的承保机构、承保、保全变更、退保和理赔办理方式及理赔金支付方式。',
  '根据《中华人民共和国合同法》第十一条规定，数据电文是合法的合同表现形式。本人接受保险公司在慧择网提供的电子保单作为本投保书成立生效的合法有效凭证，具有完全证据效力。',
  '本投保人已知晓并确认，投保本产品时如被保险人是未成年人, 其父母或监护人已知晓并同意投保人为该未成年人安排相关保险的承保。（如投保人已是未成年人的父母或监护人，则不适用于此条。）',
  '本产品为慧择保险经纪有限公司提供投保链接，相应保险经纪服务保全、理赔协助等由慧择保险经纪有限公司提供。',
];

// 保险商城cps的投保人申明
export const insuranceCpsProtocol = [
  '投保时，本投保人已就该产品的保障内容以及保险金额向被保险人进行了明确说明，并征得其同意。',
  '默认投保人为深圳市六六六国际旅行社有限公司，代替填写人作为保单上投保人，进行投保，若填写者不同意可选择指定投保人，进行投保；若出单后因保单上投保人为深圳市六六六国际旅行社有限公司，出现要求退款、修改等操作，由填写人自行负责。',
  '本投保人授权慧择保险经纪有限公司作为本人的保险经纪人，并委托慧择保险经纪全权代为办理保险相关事宜。',
  '本投保人兹声明上述各项内容填写属实，并知道如果投保信息不真实，保险公司将有权拒赔，一切后果由本人承担。',
  '本投保人已完整阅读本产品投保须知、详细条款，尤其是保障责任、免除责任、犹豫期、费用扣除、退保、保险单现金价值、投保人、被保险人义务的内容等各重要事项。本投保人特此同意接受该条款及投保须知之全部内容。',
  '本投保人已明确了解该保险合同的成立、生效是以保险公司出具保单为准，确认非以支付保费为保险合同的成立要件。',
  '本投保人已明确并接受本计划的承保机构、承保、保全变更、退保和理赔办理方式及理赔金支付方式。',
  '根据《中华人民共和国合同法》第十一条规定，数据电文是合法的合同表现形式。本人接受保险公司在慧择网提供的电子保单作为本投保书成立生效的合法有效凭证，具有完全证据效力。',
  '本投保人已知晓并确认，投保本产品时如被保险人是未成年人, 其父母或监护人已知晓并同意投保人为该未成年人安排相关保险的承保。（如投保人已是未成年人的父母或监护人，则不适用于此条。）',
  '本产品为慧择保险经纪有限公司提供投保链接，相应保险经纪服务保全、理赔协助等由慧择保险经纪有限公司提供。',
];

// 保险商品列表，前端固定数据
export const insuranceDatas = [
  {
    index: 1,
    productSeries: '“泰安心”泰签保障计划',
    productName: '“泰安心”泰签保障计划 计划一',
    region: '亚洲',
    type: '出境险',
    isHot: true,
    originPrice: 90,
    peerDiscount: 72,
    discount: 8,
    imageName: 'insurance-product-14.png',
    logo: 'qixin.png',
    caseCode: 'QX000000129266',
    securityFeatures: [
      '意外身故、伤残/30万元',
      '新型冠状病毒肺炎身故保障（等待期10天）/20万元',
      '旅行医疗费用（含新冠肺炎住院及门急诊医药费用）（新冠肺炎等待期10天）/80万元',
    ],
  },
  {
    index: 2,
    productSeries: '“泰安心”泰签保障计划',
    productName: '“泰安心”泰签保障计划 计划二',
    region: '亚洲',
    type: '出境险',
    isHot: true,
    originPrice: 100,
    peerDiscount: 80,
    discount: 8,
    imageName: 'insurance-product-15.png',
    logo: 'qixin.png',
    caseCode: 'QX000000129267',
    securityFeatures: [
      '意外身故、伤残/50万元',
      '新型冠状病毒肺炎身故保障（等待期10天）/20万元',
      '旅行医疗费用（含新冠肺炎住院及门急诊医药费用）（新冠肺炎等待期10天）/80万元',
    ],
  },
  {
    index: 3,
    productSeries: '“泰安心”泰签保障计划',
    productName: '“泰安心”泰签保障计划 计划三',
    region: '亚洲',
    type: '出境险',
    isHot: true,
    originPrice: 115,
    peerDiscount: 92,
    discount: 8,
    imageName: 'insurance-product-16.png',
    logo: 'qixin.png',
    caseCode: 'QX000000129268',
    securityFeatures: [
      '意外身故、伤残/50万元',
      '新型冠状病毒肺炎身故保障（等待期10天）/50万元',
      '旅行医疗费用（含新冠肺炎住院及门急诊医药费用）（新冠肺炎等待期10天）/80万元',
    ],
  },
  {
    index: 4,
    productSeries: '齐欣-申根轻松游',
    productName: '申根轻松游-白百合计划（附赠拒签补偿）',
    region: '申根',
    type: '出境险',
    isHot: true,
    originPrice: 90,
    peerDiscount: 72,
    discount: 8,
    imageName: 'insurance-product-2.png',
    logo: 'qixin.png',
    caseCode: 'QX000000100922',
    securityFeatures: [
      '医疗费用（意外及突发急性病医疗费用，含门诊及住院，0免赔，100%赔付）/35万',
      '紧急医疗运送和送返/30万',
      '航班延误（每5小时赔偿500元）/ 1000元',
      '行李延误（每6小时赔偿500元）/500元',
    ],
  },
  {
    index: 5,
    productSeries: '齐欣“乐游全球”境外旅行保障',
    productName: '“乐游全球”境外旅行保障-白银计划（赠拒签补偿）',
    region: '全球通用',
    type: '出境险',
    isHot: true,
    originPrice: 25,
    peerDiscount: 20,
    discount: 8,
    imageName: 'insurance-product-1.png',
    logo: 'qixin.png',
    caseCode: 'QX000000100335',
    securityFeatures: [
      '海外自驾车意外身故（与主险累计赔付）/10万',
      '医疗补偿费用（含意外及突发急性病，门诊及住院）/10万',
      '航班延误（每5小时赔偿300元）/600元',
    ],
  },

  {
    index: 6,
    productSeries: '悠游天下',
    productName: '平安悠游天下-A款',
    region: '全球通用',
    type: '出境险',
    isHot: true,
    originPrice: 2.86,
    peerDiscount: 2.57,
    discount: 9,
    imageName: 'insurance-product-9.png',
    logo: 'pingan.gif',
    caseCode: 'QX000000101449',
    securityFeatures: [
      '意外身故/伤残/18万',
      '意外和突发急性病医疗补偿/3.9万',
      '亲属慰问探访/3000元',
      '意外和急性病住院津贴/80元/天',
    ],
  },
  {
    index: 7,
    productSeries: '平安拒签保险',
    productName: '平安拒签保险-美新英澳爱计划',
    region: '美新英澳爱',
    type: '拒签险',
    isHot: true,
    originPrice: 179,
    peerDiscount: 161.1,
    discount: 9,
    imageName: 'insurance-product-10.png',
    withicon: true,
    logo: 'pingan.gif',
    caseCode: 'QX000000127347',
    securityFeatures: [
      '飞机意外身故、残疾/20万元',
      '签证拒签补偿/1100元',
    ],
  },
  {
    index: 8,
    productSeries: '平安拒签保险',
    productName: '平安拒签保险-申根计划',
    region: '申根',
    type: '拒签险',
    isHot: true,
    originPrice: 79,
    peerDiscount: 71.1,
    discount: 9,
    imageName: 'insurance-product-11.png',
    withicon: true,
    logo: 'pingan.gif',
    caseCode: 'QX000000127354',
    securityFeatures: [
      '飞机意外身故、残疾/20万元',
      '签证拒签补偿/600元',
    ],
  },
  {
    index: 9,
    productSeries: '齐欣境外轻松游',
    productName: '境外轻松游-郁金香计划',
    region: '全球通用',
    type: '出境险',
    isHot: true,
    originPrice: 40,
    peerDiscount: 32,
    discount: 8,
    imageName: 'insurance-product-3.png',
    logo: 'qixin.png',
    caseCode: 'QX000000100908',
    securityFeatures: [
      '公共交通工具意外伤害/10万',
      '医疗费用（含意外医疗及突发急性病医疗）/8万',
      '旅行延误（每5小时赔偿300元） /300元',
      '旅行证件损失/2000元',
    ],
  },
  {
    index: 10,
    productSeries: '美亚“万国游踪”境外旅行保障计划 – 全球版',
    productName: '美亚“万国游踪”境外旅行保障计划-全球探索计划',
    region: '全球通用',
    type: '出境险',
    originPrice: 90,
    peerDiscount: 72,
    discount: 8,
    imageName: 'insurance-product-7.png',
    logo: 'meiya.gif',
    caseCode: 'QX000000101220',
    securityFeatures: [
      '医疗运送和送返/50万',
      '旅行延误/600元',
      '旅行变更/5000元',
      '银行卡盗刷/5000元',
    ],
  },

  {
    index: 11,
    productSeries: '美亚“万国游踪”境外旅行保障计划 – 申根版',
    productName: '美亚“万国游踪”境外旅行保障计划-申根无忧计划',
    region: '申根',
    type: '出境险',
    originPrice: 120,
    peerDiscount: 96,
    discount: 8,
    imageName: 'insurance-product-8.png',
    logo: 'meiya.gif',
    caseCode: 'QX000000101235',
    securityFeatures: [
      '双倍给付意外伤害/30万',
      '医疗运送和送返/50万',
      '旅行延误/600元',
      '旅行变更/2000元',
    ],
  },

  {
    index: 12,
    productSeries: '美亚“乐悠游”境外旅行保障计划',
    productName: '美亚“乐悠游”境外旅行保障计划-亚洲版',
    region: '亚洲',
    type: '出境险',
    originPrice: 30,
    peerDiscount: 24,
    discount: 8,
    imageName: 'insurance-product-6.png',
    logo: 'meiya.gif',
    caseCode: 'QX000000101238',
    securityFeatures: [
      '医药补偿/5万',
      '医疗运送和送返/40万',
      '旅行证件遗失/4000元',
      '旅程延误/600元',
    ],
  },
  {
    index: 13,
    productSeries: '齐欣-俄罗斯签证旅行保障',
    productName: '齐欣-俄罗斯签证专享保障-基础版-白桦林',
    region: '俄罗斯',
    type: '出境险',
    originPrice: 90,
    peerDiscount: 72,
    discount: 8,
    imageName: 'insurance-product-5.png',
    logo: 'qixin.png',
    caseCode: 'QX000000101685',
    securityFeatures: [
      '意外身故及伤残/20万元',
      '医疗费用保险金（含门诊和住院）/30万',
      '紧急医疗运送送返/30万',
      '航班延误（每5小时赔偿300元，以保额为限）/300元',
    ],
  },

  {
    index: 14,
    productSeries: '齐欣旅游爱自由境外旅行保障',
    productName: '“爱自由”境外旅行保障-计划A',
    region: '全球通用',
    type: '出境险',
    originPrice: 110,
    peerDiscount: 88,
    discount: 8,
    imageName: 'insurance-product-4.png',
    logo: 'qixin.png',
    caseCode: 'QX000000100444',
    securityFeatures: [
      '意外身故、残疾/30万',
      '医疗费用（含门诊和住院，境内疾病医疗费用限额为3,000元，提供医疗直付服务）/30万',
      '海外救护车费用/300元',
      '旅行延误（每5小时赔偿400元）/1000元',
    ],
  },

  {
    index: 15,
    productSeries: '齐欣-申根轻松游',
    productName: '申根轻松游-木兰计划（赠拒签补偿）',
    region: '申根',
    type: '出境险',
    originPrice: 100,
    peerDiscount: 80,
    discount: 8,
    imageName: 'insurance-product-2.png',
    logo: 'qixin.png',
    caseCode: 'QX000000100923',
    securityFeatures: [
      '医疗费用（意外及突发急性病医疗费用，含门诊及住院，0免赔，100%赔付）/40万',
      '紧急医疗运送和送返/40万',
      '航班延误（每5小时赔偿500元）/1500元',
      '签证拒签保障（仅限申根签证）/500元',
    ],
  },
  {
    index: 16,
    productSeries: '齐欣-申根轻松游',
    productName: '申根轻松游-月桂计划（赠拒签补偿）',
    region: '申根',
    type: '出境险',
    originPrice: 140,
    peerDiscount: 112,
    discount: 8,
    imageName: 'insurance-product-2.png',
    logo: 'qixin.png',
    caseCode: 'QX000000100924',
    securityFeatures: [
      '医疗费用（意外及突发急性病医疗费用，含门诊及住院，0免赔，100%赔付）/40万',
      '紧急医疗运送和送返/50万',
      '航班延误（每5小时赔偿500元）/2000元',
      '签证拒签保障（仅限申根签证）/900元',
    ],
  },
  {
    index: 17,
    productSeries: '齐欣“乐游全球”境外旅行保障',
    productName: '“乐游全球”境外旅行保障-黄金计划（赠拒签补偿）',
    region: '全球通用',
    type: '出境险',
    originPrice: 40,
    peerDiscount: 32,
    discount: 8,
    imageName: 'insurance-product-1.png',
    logo: 'qixin.png',
    caseCode: 'QX000000100336',
    securityFeatures: [
      '海外自驾车意外身故（与主险累计赔付）/10万',
      '医疗补偿费用（含意外及突发急性病，门诊及住院）/30万',
      '航班延误（每5小时赔偿300元）/900元',
      '签证拒签补偿（补偿拒签后签证费损失的50%）/ 300元',
    ],
  },
  {
    index: 18,
    productSeries: '齐欣“乐游全球”境外旅行保障',
    productName: '“乐游全球”境外旅行保障-钻石计划（赠拒签补偿）',
    region: '全球通用',
    type: '出境险',
    originPrice: 55,
    peerDiscount: 44,
    discount: 8,
    imageName: 'insurance-product-1.png',
    logo: 'qixin.png',
    caseCode: 'QX000000100337',
    securityFeatures: [
      '海外自驾车意外身故（与主险累计赔付）/10万',
      '医疗补偿费用（含意外及突发急性病，门诊及住院）/50万',
      '航班延误（每5小时赔偿300元）/1200元',
      '签证拒签补偿（补偿拒签后签证费损失的50%）/ 900元',
    ],
  },
  {
    index: 19,
    productSeries: '悠游天下',
    productName: '平安悠游天下-B款',
    region: '全球通用',
    type: '出境险',
    originPrice: 8.57,
    peerDiscount: 7.71,
    discount: 9,
    imageName: 'insurance-product-9.png',
    logo: 'pingan.gif',
    caseCode: 'QX000000101450',
    securityFeatures: [
      '意外身故/伤残/30万',
      '意外和突发急性病医疗补偿/4.5万',
      '亲属慰问探访/5000元',
      '意外和急性病住院津贴/100元/天',
    ],
  },
  {
    index: 20,
    productSeries: '悠游天下',
    productName: '平安悠游天下-C款',
    region: '全球通用',
    type: '出境险',
    originPrice: 15.71,
    peerDiscount: 14.14,
    discount: 9,
    imageName: 'insurance-product-9.png',
    logo: 'pingan.gif',
    caseCode: 'QX000000101451',
    securityFeatures: [
      '意外身故/伤残/50万',
      '意外和突发急性病医疗补偿/5万',
      '亲属慰问探访/5000元',
      '意外和急性病住院津贴/100元/天',
    ],
  },

  {
    index: 21,
    productSeries: '平安拒签保险',
    productName: '平安拒签保险-加拿大计划',
    region: '加拿大',
    type: '拒签险',
    originPrice: 129,
    peerDiscount: 116.1,
    discount: 9,
    imageName: 'insurance-product-13.png',
    withicon: true,
    logo: 'pingan.gif',
    caseCode: 'QX000000127353',
    securityFeatures: [
      '飞机意外身故、残疾/20万元',
      '签证拒签补偿/700元',
    ],
  },
  {
    index: 22,
    productSeries: '平安拒签保险',
    productName: '平安拒签保险-其他计划',
    region: '其他',
    type: '拒签险',
    originPrice: 49,
    peerDiscount: 44.1,
    discount: 9,
    imageName: 'insurance-product-12.png',
    withicon: true,
    logo: 'pingan.gif',
    caseCode: 'QX000000127355',
    securityFeatures: [
      '飞机意外身故、残疾/20万元',
      '签证拒签补偿/500元',
    ],
  },

  {
    index: 23,
    productSeries: '齐欣境外轻松游',
    productName: '境外轻松游-椰枣计划',
    region: '全球通用',
    type: '出境险',
    originPrice: 55,
    peerDiscount: 44,
    discount: 8,
    imageName: 'insurance-product-3.png',
    logo: 'qixin.png',
    caseCode: 'QX000000100909',
    securityFeatures: [
      '公共交通工具意外伤害/10万',
      '医疗费用（含意外医疗及突发急性病医疗）/10万',
      '旅行延误（每5小时赔偿400元）/400元',
      '旅行证件损失/5000元',
    ],
  },


  {
    index: 24,
    productSeries: '齐欣境外轻松游',
    productName: '境外轻松游-雪松计划',
    region: '全球通用',
    type: '出境险',
    originPrice: 30,
    peerDiscount: 24,
    discount: 8,
    imageName: 'insurance-product-3.png',
    logo: 'qixin.png',
    caseCode: 'QX000000100907',
    securityFeatures: [
      '公共交通工具意外伤害/10万',
      '医疗费用（含意外医疗及突发急性病医疗）/5万',
      '旅行延误（每5小时赔偿200元）/200元',
    ],
  },

  {
    index: 25,
    productSeries: '美亚“万国游踪”境外旅行保障计划 – 全球版',
    productName: '美亚“万国游踪”境外旅行保障计划-全球无忧计划',
    region: '全球通用',
    type: '出境险',
    originPrice: 155,
    peerDiscount: 120,
    discount: 8,
    imageName: 'insurance-product-7.png',
    logo: 'meiya.gif',
    caseCode: 'QX000000101219',
    securityFeatures: [
      '医疗运送和送返/150万',
      '旅行延误/900元',
      '旅行变更/5000元',
      '银行卡盗刷/1万元',
    ],
  },

  {
    index: 26,
    order: 999,
    productSeries: '美亚“万国游踪”境外旅行保障计划 – 全球版',
    productName: '美亚“万国游踪”境外旅行保障计划-全球完美计划',
    region: '全球通用',
    type: '出境险',
    originPrice: 250,
    peerDiscount: 188,
    discount: 8,
    imageName: 'insurance-product-7.png',
    logo: 'meiya.gif',
    caseCode: 'QX000000101221',
    securityFeatures: [
      '医疗运送和送返/实际费用',
      '旅行延误/1800元',
      '旅行变更/2万',
      '银行卡盗刷/1.5万',
    ],
  },

  {
    index: 27,
    productSeries: '美亚“万国游踪”境外旅行保障计划 – 申根版',
    productName: '美亚“万国游踪”境外旅行保障计划-申根完美计划',
    region: '申根',
    type: '出境险',
    originPrice: 150,
    peerDiscount: 112,
    discount: 8,
    imageName: 'insurance-product-8.png',
    logo: 'meiya.gif',
    caseCode: 'QX000000101237',
    securityFeatures: [
      '双倍给付意外伤害/40万',
      '医疗运送和送返/100万',
      '旅行延误/1800元',
      '旅行变更/5000元',
    ],
  },

  {
    index: 28,
    productSeries: '齐欣-俄罗斯签证旅行保障',
    productName: '齐欣-俄罗斯签证专享保障-升级版-贝加尔',
    region: '俄罗斯',
    type: '出境险',
    originPrice: 110,
    peerDiscount: 88,
    discount: 8,
    imageName: 'insurance-product-5.png',
    logo: 'qixin.png',
    caseCode: 'QX000000101686',
    securityFeatures: [
      '意外身故及伤残/30万元',
      '医疗费用保险金（含门诊和住院）/35万',
      '紧急医疗运送送返/30万',
      '航班延误（每5小时赔偿300元，以保额为限）/600元',
    ],
  },
  {
    index: 29,
    productSeries: '齐欣-俄罗斯签证旅行保障',
    productName: '齐欣-俄罗斯签证专享保障-尊享版-天鹅湖',
    region: '俄罗斯',
    type: '出境险',
    originPrice: 150,
    peerDiscount: 120,
    discount: 8,
    imageName: 'insurance-product-5.png',
    logo: 'qixin.png',
    caseCode: 'QX000000101687',
    securityFeatures: [
      '意外身故及伤残/50万元',
      '医疗费用保险金（含门诊和住院）/35万',
      '紧急医疗运送送返/35万',
      '航班延误（每5小时赔偿300元，以保额为限）/900元',
    ],
  },

  {
    index: 30,
    productSeries: '齐欣旅游爱自由境外旅行保障',
    productName: '“爱自由”境外旅行保障-计划B',
    region: '全球通用',
    type: '出境险',
    originPrice: 180,
    peerDiscount: 144,
    discount: 8,
    imageName: 'insurance-product-4.png',
    logo: 'qixin.png',
    caseCode: 'QX000000100445',
    securityFeatures: [
      '意外身故、残疾/50万',
      '医疗费用（含门诊和住院，境内疾病医疗费用限额为3,000元，提供医疗直付服务）/35万',
      '海外救护车费用/500元',
      '旅行延误（每5小时赔偿400元）/2000元',
    ],
  },
  {
    index: 31,
    productSeries: '齐欣旅游爱自由境外旅行保障',
    productName: '“爱自由”境外旅行保障-计划C',
    region: '全球通用',
    type: '出境险',
    originPrice: 235,
    peerDiscount: 188,
    discount: 8,
    imageName: 'insurance-product-4.png',
    logo: 'qixin.png',
    caseCode: 'QX000000100446',
    securityFeatures: [
      '意外身故、残疾/60万',
      '医疗费用（含门诊和住院，境内疾病医疗费用限额为3,000元，提供医疗直付服务）/40万',
      '海外救护车费用/800元',
      '旅行延误（每5小时赔偿400元）/3000元',
    ],
  },
  {
    index: 32,
    productSeries: '齐欣旅游爱自由境外旅行保障',
    productName: '“爱自由”境外旅行保障-计划D',
    region: '全球通用',
    type: '出境险',
    originPrice: 290,
    peerDiscount: 232,
    discount: 8,
    imageName: 'insurance-product-4.png',
    logo: 'qixin.png',
    caseCode: 'QX000000100447',
    securityFeatures: [
      '意外身故、残疾/100万',
      '医疗费用（含门诊和住院，境内疾病医疗费用限额为3,000元，提供医疗直付服务）/40万',
      '海外救护车费用/800元',
      '旅行延误（每5小时赔偿400元）/3000元',
    ],
  },

  // {
  //   index: 21,
  //   productSeries: '平安快乐旅程III',
  //   productName: '平安快乐旅程III  计划一',
  //   region: '亚洲地区',
  //   originPrice: 50,
  //   peerDiscount: 45,
  //   discount: 9,
  //   imageName: 'asia-2.jpg',
  //   logo: 'pingan.gif',
  //   caseCode: 'QX000000101454',
  //   securityFeatures: [
  //     '意外身故、残疾/10万',
  //     '意外和突发急性病医疗补偿/10万',
  //     '医疗运送和送返/50万',
  //     '亲属慰问探访补偿/13000元',
  //   ],
  // },
  // {
  //   index: 22,
  //   productSeries: '平安快乐旅程III',
  //   productName: '平安快乐旅程III  计划二',
  //   region: '亚洲地区',
  //   originPrice: 115,
  //   peerDiscount: 103.5,
  //   discount: 9,
  //   imageName: 'asia-2.jpg',
  //   logo: 'pingan.gif',
  //   caseCode: 'QX000000101453',
  //   securityFeatures: [
  //     '意外身故、残疾/30万',
  //     '意外和突发急性病医疗补偿/30万',
  //     '医疗运送和送返/200万',
  //     '旅行延误 (每5小时延误赔偿300元，以保额为限)/1200元',
  //   ],
  // },
  // {
  //   index: 23,
  //   productSeries: '平安快乐旅程III',
  //   productName: '平安快乐旅程III  计划三',
  //   region: '亚洲地区',
  //   originPrice: 185,
  //   peerDiscount: 166.5,
  //   discount: 9,
  //   imageName: 'asia-2.jpg',
  //   logo: 'pingan.gif',
  //   caseCode: 'QX000000101452',
  //   securityFeatures: [
  //     '意外身故、残疾/60万',
  //     '意外和突发急性病医疗补偿/40万',
  //     '医疗运送和送返/400万',
  //     '旅行延误 (每5小时延误赔偿300元，以保额为限)/1200元',
  //   ],
  // },

  // {
  //   index: 31,
  //   productSeries: '“安心游”邮轮旅行保险',
  //   productName: '“安心游”邮轮旅行保险',
  //   region: '亚洲地区',
  //   originPrice: 15,
  //   peerDiscount: 14.25,
  //   discount: 9.5,
  //   imageName: 'cruise.jpg',
  //   logo: 'pingan.gif',
  //   caseCode: 'QX000000101344',
  //   securityFeatures: [
  //     '意外身故、残疾/20万',
  //     '紧急医疗运送和送返/30万',
  //     '旅行延误(含母港出发延误、目的地港口到达延误、母港返港延误；每8小时赔偿250元，以保额为限)/500元',
  //     '旅行取消/3000元',
  //   ],
  // },
  // {
  //   index: 32,
  //   productSeries: '南北极旅游保障计划',
  //   productName: '南北极旅游保障计划',
  //   region: '全球通用',
  //   originPrice: 210,
  //   peerDiscount: 189,
  //   discount: 9,
  //   imageName: 'north-and-south-pole.jpg',
  //   logo: 'pingan.gif',
  //   caseCode: 'QX000000002758',
  //   securityFeatures: [
  //     '意外和疾病住院和门诊急诊/40万',
  //     '医疗运送和送返/100万',
  //     '轮船意外伤害身故和残疾/60万',
  //     '旅行延误(每延误5小时赔偿RMB300元，以保额为限)/1800元',
  //   ],
  // },
];

export const fakeData = {
  product_name: '美亚“万国游踪”境外旅行保障计划–全球版',
  plan_name: '白百合计划',
  case_code: 'QX000000101220',
  logo: 'http://files.hzins.com/images/b/b0/b00/b003/c736cc198f9c4f34b3410d840f3c.gif',
  insurant_age: '17-85周岁',
  travel_delays: 1,
  start_date: '2018-04-18',
  end_date: '2018-04-22',
  protect_days: '1-7天',
  destination: '科威特',
  applicant: {
    cname: '光头强',
    ename: 'Bald Strong',
    card_type: 2,
    card_code: 'EC471230',
    sex: 1,
    birthday: '1995-01-01',
    mobile: '13913231023',
    email: 'xxx@...',
  },
  insurants: [
    {
      cname: '光头强1',
      ename: 'Bald Strong1',
      card_type: 2,
      card_code: '880888198808288888',
      sex: 1,
      birthday: '1995-01-01',
    },
    {
      cname: '光头强2',
      ename: 'Bald Strong2',
      card_type: 2,
      card_code: 'EC471231',
      sex: 1,
      birthday: '1995-01-01',
    },
    {
      cname: '光头强1',
      ename: 'Bald Strong1',
      card_type: 2,
      card_code: '880888198808288888',
      sex: 1,
      birthday: '1995-01-01',
    },
    {
      cname: '光头强2',
      ename: 'Bald Strong2',
      card_type: 2,
      card_code: 'EC471231',
      sex: 1,
      birthday: '1995-01-01',
    },
  ],
  destinations: [
    {
      cname: '阿曼',
      initial: 'A',
      continent_id: 1,
      ename: 'Oman',
      continent_name: '亚洲',
    },
    {
      cname: '巴林',
      initial: 'B',
      continent_id: 1,
      ename: 'Bahrain',
      continent_name: '亚洲',
    },
  ],
  insure_date_range: [
    {
      value: '1-7',
      step: 0,
      unit: '天',
      max: 7,
      min: 1,
      type: '1',
    },
    {
      value: '29-182',
      step: 1,
      unit: '天',
      max: 182,
      min: 29,
      type: '2',
    },
    {
      value: '1',
      step: 0,
      unit: '年',
      max: 1,
      min: 1,
      type: '1',
    },
  ],
  single_price: 15000,
  balance_amount: '99900',
};



// WEBPACK FOOTER //
// ./src/datas/insurance-products.js